// extracted by mini-css-extract-plugin
export default {"row":"PlansRow__row-uoxqJ","label":"PlansRow__label-XKpUb","planName":"PlansRow__planName-BXhK4","checkbox":"PlansRow__checkbox-rg5n2","includedApps":"PlansRow__includedApps-kRoNF"};